module.exports = __webpack_public_path__ + "img/ct@2x.33231bad.png";